import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import compose from '@shopify/react-compose'
import { withTranslation } from 'react-i18next'

import { Header, withConfiguration,Notification } from '@portal/kit/pkg/components'
import { formatToInternationalPhoneNumber } from '@portal/kit/pkg/helpers'
import styles from './layout-style'

const hotlineNumber = portalConfiguration => {
  if (!portalConfiguration || !portalConfiguration.locales_variables) return null
  return formatToInternationalPhoneNumber(portalConfiguration.locales_variables.hotline, portalConfiguration.country)
}

const Layout = props => {
  const classes = styles(props.theme)
  return (
    <Fragment>
      <span className={classes.globalLayer} />
      <div className={classes.main}>
        <Header classType="withShadow" {...props.headerProps} />
        <div className={classes.content}>
          {props.portalConfiguration.silent_mode && <Notification status="fail" message={props.t('internet_access.silent_mode')}/>}
          <div id="notification" />
          {props.children}
        </div>
        <footer className={classes.footer}>
        <span className={classes.footerLine}>
          <span className={classes.footerItem}>
            <a href="https://www.wifirst.com" target="_blank" rel="noopener noreferrer" className={classes.footerItemLink}>{props.t('footer.provided_by_wifirst')}</a>
          </span>
          <span className={classes.footerItem}>
            <a href="https://www.wifirst.com/mentions-legales" target="_blank" rel="noopener noreferrer" className={classes.footerItemLink}>{props.t('footer.legal')}</a>
          </span>
        </span>
          <span className={classes.footerLine}>
          <span className={classes.footerItem}>{props.t('footer.hotline')} <a href={`tel:${hotlineNumber(props.portalConfiguration)}`} className={classes.footerItemLink}>{hotlineNumber(props.portalConfiguration)}</a></span>
            {
              props.portalConfiguration.tag === 'iloscamonde' && (
                <span className={classes.footerItem}>
                <a href={`/pdf/${props.i18n.language.toLowerCase()}/FAQ.pdf`} target="_blank" rel="noopener noreferrer" className={classes.footerItemLink}>FAQ</a>
              </span>
              )
            }
            <span className={classes.footerItem}>{props.t('footer.copyright')}</span>
        </span>
        </footer>
      </div>
    </Fragment>
  )
}


Layout.propTypes = {
  children: PropTypes.node,
  headerProps: PropTypes.object,
  portalConfiguration: PropTypes.object.isRequired,
}

Layout.defaultProps = {
  headerProps: {},
}

export default compose(
  withTranslation(),
  withConfiguration
)(Layout)
